import type { SalesorderDocument } from "../types";
import { createDateColumn, createStringColumn } from "./columnHelpers";

const namespace = "salesorders";

export const salesorderColumns = [
    createStringColumn<SalesorderDocument>({
        namespace,
        field: "metadata._id",
        header: "Salesorder Number",
    }),
    createStringColumn<SalesorderDocument>({
        namespace,
        field: "metadata.Engine",
        header: "Engine",
    }),
    createDateColumn<SalesorderDocument>({
        namespace,
        field: "metadata.date_timestamp",
        header: "Date",
    }),
    createStringColumn<SalesorderDocument>({
        namespace,
        field: "metadata.Customer Name",
        header: "Customer Name",
    }),
    createStringColumn<SalesorderDocument>({
        namespace,
        field: "metadata.TUL Number",
        header: "TUL Number",
    }),
    createDateColumn<SalesorderDocument>({
        namespace,
        field: "metadata.last_amended_timestamp",
        header: "Last Amended",
    }),
    createStringColumn<SalesorderDocument>({
        namespace,
        field: "metadata.Product Line",
        header: "Product Line",
    }),
];
